var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchRankingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 5",
    d: "M9.04375 1.53L5.848 6.6432C5.45633 7.26987 4.54367 7.26987 4.152 6.6432L0.956249 1.53C0.539969 0.863952 1.01881 4.76837e-07 1.80425 4.76837e-07L8.19575 4.76837e-07C8.98119 4.76837e-07 9.46003 0.863951 9.04375 1.53Z",
    fill: "#4A9AD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRankingDown);
export default __webpack_public_path__ + "static/media/search_ranking_down.20a09e0387ca9492fb6c95355fe39d74.svg";
export { ForwardRef as ReactComponent };